import NotificationScreen from "@/src/screens/notification/notification";

export default function Notification() {
  return <NotificationScreen />;
}
